/*
  assets/nibec-elevado.js · Bigbuda · T-0953 (20-oct-2026, rama cotizador/T-0953-elevado)
  Script de la capa «Nibec · Diseño elevado» (layout/theme.liquid lo carga con defer solo con el ajuste encendido). Hace una sola cosa:
    1) Encabezado fijo que se achica al bajar: pone y quita clases en <body> según el scroll; todo lo visual está en assets/nibec-elevado.css.
         · nibec-hdr-comp      = se bajó más de 40 px: logo y alturas se reducen y aparece la sombra. Vuelve a ser grande al llegar arriba (< 8 px).
         · nibec-hdr-off       = se baja (más de 140 px): el menú de categorías (y el buscador en celular) se oculta. Reaparece al subir.
       No cambia el marcado ni el script del encabezado de Diego (sections/nibec-header.liquid): el «sticky-header» sigue poniendo sus clases y el CSS las neutraliza.
       Publica --ne-hdr (alto visible del encabezado) y --ne-hdr-full (alto del encabezado con el menú a la vista) para que nada de abajo se mueva.
  Sin dependencias, sin peticiones, ~3 KB. Se apaga con el ajuste del tema; si falla, el sitio queda exactamente como antes (todo es progresivo).
*/
(function () {
  'use strict';
  var body = document.body;
  if (!body || !body.classList.contains('nibec-elev')) return;
  var root = document.documentElement;

  /* ── Enlace activo del menú: la categoría de la página actual (colecciones y fichas dentro de una colección) lleva aria-current="page" ── */
  try {
    var ruta = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.nibec-header__nav a[href], .nibec-drawer__item[href]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '');
      if (h.indexOf('/collections/') === 0 && (ruta === h || ruta.indexOf(h + '/') === 0)) a.setAttribute('aria-current', 'page');
    });
  } catch (e) {}

  /* ── Elementos fijos (celular): estados que el CSS usa para que la barra «Cotiza lo que necesites» y el flotante de WhatsApp no tapen botones, títulos ni el pie ── */
  if ('IntersectionObserver' in window) {
    var vigilar = function (selector, clase) {
      var el = document.querySelector(selector);
      if (!el) return;
      new IntersectionObserver(function (es) { body.classList.toggle(clase, es[0].isIntersecting); }, { threshold: 0 }).observe(el);
    };
    vigilar('.nibec-hero__actions', 'ne-cta-visible');
    vigilar('h1.nibec-pdp__titulo', 'ne-titulo-visible');
    vigilar('.shopify-section-group-footer-group', 'ne-pie-visible');
  }
  var pasada = false;
  var marcarPasada = function () {
    var ya = (window.pageYOffset || 0) > 360;
    if (ya !== pasada) { pasada = ya; body.classList.toggle('ne-pasada', ya); }
  };
  window.addEventListener('scroll', marcarPasada, { passive: true });
  marcarPasada();

  /* ── WhatsApp flotante que se lee siempre: elige su variante («claro» negro / «oscuro» blanco) según el fondo que tiene debajo ──
        Muestrea 15 puntos (rejilla 5 × 3) bajo el botón con elementsFromPoint (el primer elemento que no es el botón), busca el primer fondo opaco hacia arriba y calcula su luminancia relativa
        (WCAG). Si ≥ 40 % de los puntos son oscuros (L < 0,18: con blanco encima da ≥ 4,5:1), variante «oscuro». Fotos y videos cuentan como «claro» (el aro lo separa igual).
        Cuesta casi nada: como máximo un muestreo por cuadro, solo al hacer scroll o cambiar de tamaño (más un repaso cada 0,9 s por carruseles y animaciones), sin leer
        estilos del botón; para cambiar pide el mismo resultado en 2 muestreos seguidos (sin parpadeo). Sin JavaScript queda la variante «claro». ── */
  if (body.classList.contains('nibec-elev--wa') && document.elementsFromPoint) {
    var flot = null, vistoWa = 'claro', candWa = 'claro', seguidosWa = 0, progWa = false;
    var lumi = function (c) {
      var m = /rgba?\(\s*([\d.]+)[ ,]+([\d.]+)[ ,]+([\d.]+)(?:[ ,\/]+([\d.]+))?/.exec(c || '');
      if (!m) return null;
      if (m[4] !== undefined && +m[4] < 0.5) return null;
      var f = function (v) { v = +v / 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
      return 0.2126 * f(m[1]) + 0.7152 * f(m[2]) + 0.0722 * f(m[3]);
    };
    var fondoWa = function (el) {
      for (var e = el; e && e.nodeType === 1; e = e.parentElement) {
        var t = e.tagName;
        if (t === 'IMG' || t === 'VIDEO' || t === 'PICTURE' || t === 'CANVAS') return 1;
        var cs = getComputedStyle(e);
        if (cs.backgroundImage && cs.backgroundImage.indexOf('url(') > -1) return 1;
        var l = lumi(cs.backgroundColor);
        if (l !== null) return l;
      }
      return 1;
    };
    var PUNTOS = [];
    [0.25, 0.5, 0.75].forEach(function (fy) { [0.1, 0.3, 0.5, 0.7, 0.9].forEach(function (fx) { PUNTOS.push([fx, fy]); }); }); // rejilla de 5 × 3 = 15 puntos bajo el botón
    var muestrearWa = function () {
      progWa = false;
      if (!flot || !flot.isConnected) flot = document.querySelector('.nq-float');
      if (!flot || document.hidden || !flot.classList.contains('nq-in')) return;
      var r = flot.getBoundingClientRect();
      if (r.width < 8 || r.bottom < 0 || r.top > window.innerHeight) return;
      var oscuros = 0;
      for (var i = 0; i < PUNTOS.length; i++) {
        var pila = document.elementsFromPoint(r.left + r.width * PUNTOS[i][0], r.top + r.height * PUNTOS[i][1]);
        var el = null;
        for (var k = 0; k < pila.length; k++) {
          var q = pila[k];
          // se saltan: el propio botón, <html>, los iframes (p. ej. la barra de vista previa de Shopify, PBarNextFrame) y los diálogos modales abiertos (aviso emergente), que tapan la página pero no son su fondo
          if (flot.contains(q) || q === document.documentElement || q.tagName === 'IFRAME' || (q.closest && q.closest('dialog, .nibec-aviso__dialogo'))) continue;
          el = q; break;
        }
        if (el && fondoWa(el) < 0.18) oscuros++;
      }
      var nuevo = oscuros >= Math.ceil(PUNTOS.length * 0.4) ? 'oscuro' : 'claro'; // ≥ 40 % del botón sobre fondo oscuro
      if (nuevo === vistoWa) { seguidosWa = 0; candWa = nuevo; return; }
      if (nuevo === candWa) seguidosWa++; else { candWa = nuevo; seguidosWa = 1; }
      if (seguidosWa >= 2) {
        vistoWa = nuevo; seguidosWa = 0;
        if (nuevo === 'oscuro') flot.setAttribute('data-ne-fondo', 'oscuro'); else flot.removeAttribute('data-ne-fondo');
      } else { programarWa(); }
    };
    var programarWa = function () { if (!progWa) { progWa = true; window.requestAnimationFrame(muestrearWa); } };
    window.addEventListener('scroll', programarWa, { passive: true });
    window.addEventListener('resize', programarWa);
    window.addEventListener('load', programarWa);
    window.setInterval(programarWa, 900);
    programarWa();
  }

  /* ── Cajón del carrito: el escalonado de entrada solo al ABRIR (Dawn vuelve a dibujar el cajón en cada cambio de cantidad: sin esto, las líneas
        volverían a entrar con cada «+»). El atributo dura lo que dura la animación (≈ 0,9 s); el CSS (nibec-elevado-cajon.css) lo usa como interruptor. ── */
  if (body.classList.contains('nibec-elev--cajon') && 'MutationObserver' in window) {
    var cajon = document.querySelector('cart-drawer');
    if (cajon) {
      var reloj = 0;
      new MutationObserver(function () {
        if (cajon.classList.contains('active')) {
          if (!cajon.hasAttribute('data-ne-abre') && !cajon.__neVisto) {
            cajon.__neVisto = true;
            cajon.setAttribute('data-ne-abre', '');
            window.clearTimeout(reloj);
            reloj = window.setTimeout(function () { cajon.removeAttribute('data-ne-abre'); }, 900);
          }
        } else {
          cajon.__neVisto = false;
          cajon.removeAttribute('data-ne-abre');
        }
      }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ── Franja de confianza del héroe (celular): marca qué borde tiene más datos para difuminarlo (ver assets/nibec-elevado-superficies.css) ── */
  if (body.classList.contains('nibec-elev--sup')) {
    var lista = document.querySelector('[data-franja-lista]');
    if (lista) {
      var borde = function () {
        var max = lista.scrollWidth - lista.clientWidth;
        var v = max <= 1 ? 'todo' : lista.scrollLeft <= 2 ? 'ini' : lista.scrollLeft >= max - 2 ? 'fin' : 'med';
        if (lista.getAttribute('data-borde') !== v) lista.setAttribute('data-borde', v);
      };
      lista.addEventListener('scroll', borde, { passive: true });
      window.addEventListener('resize', borde);
      borde();
    }
  }

  /* ── Regiones que se desplazan de lado sin nada enfocable dentro (tira de reseñas, anuncios): sin un punto de foco el teclado no puede moverlas (axe: scrollable-region-focusable, WCAG 2.1.1).
        Se les pone tabindex="0" y, si no tienen nombre, uno tomado de su título o genérico; el contorno de foco está en nibec-elevado.css (data-ne-scroll). Solo mira los candidatos conocidos. ── */
  if (body.classList.contains('nibec-elev--scrollfoco')) {
    var regionesDesplazables = function () {
      var cand = document.querySelectorAll('[data-pista], .slider');
      for (var i = 0; i < cand.length; i++) {
        var c = cand[i];
        if (c.hasAttribute('data-ne-scroll')) { if (c.scrollWidth <= c.clientWidth + 1 && c.scrollHeight <= c.clientHeight + 1) { c.removeAttribute('data-ne-scroll'); c.removeAttribute('tabindex'); } continue; }
        var ox = getComputedStyle(c).overflowX;
        if (!/(auto|scroll)/.test(ox) || c.scrollWidth <= c.clientWidth + 1) continue;
        var dentro = c.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'), hayFoco = false;
        for (var j = 0; j < dentro.length && !hayFoco; j++) { var f = dentro[j]; hayFoco = f.tabIndex >= 0 && !f.disabled && f.getClientRects().length > 0 && !f.closest('[aria-hidden="true"], [inert]'); } // enfocable de verdad: en el orden del teclado, visible y no oculto a lectores
        if (hayFoco) continue;
        c.setAttribute('tabindex', '0');
        c.setAttribute('data-ne-scroll', '');
        if (!c.getAttribute('aria-label') && !c.getAttribute('aria-labelledby')) {
          var sec = c.closest('section, [id^="shopify-section-"]');
          var tit = sec && sec.querySelector('h1, h2, h3');
          c.setAttribute('aria-label', (tit && tit.textContent.trim()) || (/announcement/i.test(c.id) ? 'Anuncios' : 'Contenido desplazable'));
        }
      }
    };
    window.addEventListener('load', regionesDesplazables);
    window.addEventListener('resize', function () { window.clearTimeout(regionesDesplazables.t); regionesDesplazables.t = window.setTimeout(regionesDesplazables, 250); });
    regionesDesplazables();
  }

  /* ── Encabezado ─────────────────────────────────────────────────────────── */
  if (body.classList.contains('nibec-elev--hdr')) {
    var envoltorio = document.querySelector('.nibec-header-wrapper');
    var seccion = document.querySelector('.section-header');
    if (envoltorio && seccion) {
      var hdrt = body.classList.contains('nibec-elev--hdrt'); // versión con transform: la caja no cambia; se compacta ya con la cabecera pegada arriba (la barra de anuncios mide ~45 px)
      var COMP_ON = hdrt ? 60 : 40, COMP_OFF = hdrt ? 14 : 8, OCULTAR_DESDE = 140, UMBRAL = 6;
      var ultimo = window.pageYOffset || 0;
      var pendiente = false;
      var cronometro = 0;

      var medir = function () {
        if (medir.ocupado) return;
        medir.ocupado = true;
        // Alto con el menú a la vista (sin las clases dinámicas): el contenedor fijo reserva ese alto y la página no se mueve al achicar.
        var comp = body.classList.contains('nibec-hdr-comp');
        var off = body.classList.contains('nibec-hdr-off');
        seccion.style.removeProperty('height');
        body.classList.remove('nibec-hdr-comp', 'nibec-hdr-off');
        var completo = Math.round(envoltorio.getBoundingClientRect().height);
        if (comp) body.classList.add('nibec-hdr-comp');
        if (off) body.classList.add('nibec-hdr-off');
        if (completo > 0) root.style.setProperty('--ne-hdr-full', completo + 'px');
        visible();
        medir.ocupado = false;
      };
      var visible = function () {
        var h = Math.round(envoltorio.getBoundingClientRect().height);
        // con transform el alto de la caja no cambia: lo visible es el alto menos lo que el envoltorio subió (translate negativo)
        if (hdrt && h > 0) { var ty = parseFloat((getComputedStyle(envoltorio).translate || '0 0').split(' ')[1]) || 0; h = Math.max(0, Math.round(h + ty)); }
        if (h > 0) {
          root.style.setProperty('--ne-hdr', h + 'px');
          root.style.scrollPaddingTop = h + 12 + 'px'; // los enlaces con # y scrollIntoView aterrizan bajo el encabezado fijo
        }
      };
      /* ── Franja de categorías de la portada bajo la cabecera fija (Marcel, 21-oct 09:30, dos capturas): al bajar, la franja pasa por debajo de la cabecera compacta y asomaba recortada
            (círculos cortados por el borde blanco y las etiquetas sueltas justo bajo el menú, como un segundo menú «raro y feo»). Cuando casi la mitad ya quedó bajo la cabecera se apaga
            (solo opacidad: nada se mueve, cero CLS) y vuelve al subir; con histéresis (se apaga al 45 %, vuelve al 25 %) para no parpadear. Solo en la portada (en el resto no hay franja). ── */
      var franja = document.querySelector('.nibec-catbar');
      var franjaOculta = false;
      var vigilarFranja = function () {
        if (!franja) return;
        var r = franja.getBoundingClientRect();
        if (r.height <= 0) return;
        var bajo = (envoltorio.getBoundingClientRect().bottom - r.top) / r.height; // fracción de la franja que ya quedó bajo el borde visible de la cabecera
        var q = franjaOculta ? bajo > 0.25 : bajo >= 0.45;
        if (q !== franjaOculta) { franjaOculta = q; body.classList.toggle('ne-franja-bajo-hdr', q); }
      };
      var algoAbierto = function () {
        // No se oculta nada mientras se escribe en el buscador, hay un menú abierto o el cajón tapa la página.
        var activo = document.activeElement;
        if (activo && activo !== document.body && envoltorio.contains(activo) && /^(INPUT|SELECT|TEXTAREA)$/.test(activo.tagName)) return true;
        if (envoltorio.querySelector('details[open]')) return true;
        return /overflow-hidden/.test(body.className);
      };
      var aplicar = function () {
        pendiente = false;
        vigilarFranja();
        // Con el cajón del menú abierto el encabezado no cambia de estado (el bloqueo de scroll de iOS mueve la posición): siempre completo y quieto.
        if (envoltorio.querySelector('details[open]') || /overflow-hidden/.test(body.className)) { body.classList.remove('nibec-hdr-off'); return; }
        var y = window.pageYOffset || 0;
        var comp = body.classList.contains('nibec-hdr-comp');
        if (!comp && y > COMP_ON) body.classList.add('nibec-hdr-comp');
        else if (comp && y < COMP_OFF) body.classList.remove('nibec-hdr-comp', 'nibec-hdr-off');
        var d = y - ultimo;
        if (Math.abs(d) >= UMBRAL) {
          if (d > 0 && y > OCULTAR_DESDE && !algoAbierto()) body.classList.add('nibec-hdr-off');
          else if (d < 0) body.classList.remove('nibec-hdr-off');
          ultimo = y;
        }
        if (y <= 0) ultimo = 0;
        // El alto visible cambia cuando termina la transición; se publica al final y no en cada cuadro (y se vuelve a mirar la franja con la cabecera ya quieta).
        window.clearTimeout(cronometro);
        cronometro = window.setTimeout(function () { visible(); vigilarFranja(); }, 340);
      };
      window.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(aplicar);
      }, { passive: true });
      // Quien navega con teclado o escribe en el buscador siempre ve el menú.
      envoltorio.addEventListener('focusin', function () { body.classList.remove('nibec-hdr-off'); });
      var recalcular = function () { window.clearTimeout(medir.t); medir.t = window.setTimeout(medir, 160); };
      window.addEventListener('resize', recalcular);
      window.addEventListener('orientationchange', recalcular);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);
      medir();
      aplicar();
      // Si el encabezado cambia de alto con el menú a la vista (fuentes, logo, avisos), se vuelve a medir: así lo reservado nunca queda más bajo que lo real.
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () {
          if (body.classList.contains('nibec-hdr-comp') || body.classList.contains('nibec-hdr-off') || medir.ocupado) return;
          var h = Math.round(envoltorio.getBoundingClientRect().height);
          if (h > 0 && h !== parseInt(getComputedStyle(root).getPropertyValue('--ne-hdr-full'), 10)) recalcular();
        });
        ro.observe(envoltorio);
      }
    }
  }
})();
